import { toast } from "react-toastify";
import axios from "axios";

/** Format price for display (RTL): 0 => "مجاناً", otherwise "د.ل X " */
export const formatPrice = (price: number | string | undefined | null): string => {
  if (price == null || price === undefined || price === "") return "—";
  const n = typeof price === "string" ? parseFloat(price) : Number(price);
  if (Number.isNaN(n)) return "—";
  return n === 0 ? "مجاناً" : `د.ل ${n} `;
};

export const isHasRx: (rx: any) => boolean = (rx: any): boolean => {
  if (!rx) return false;
  const numbers = Object.values(rx).map((rx: any) => Object.values(rx));
  return numbers.some((rx: any) => rx.some((val: any) => val != ""));
};

export const isHighIndexed = (rx: any): boolean => {
  if (!rx) return false;
  const numbers = Object.values(rx).map((rx: any) => Object.values(rx));
  return numbers.some((rx: any) => rx.some((val: any) => val > 4 || val < -4));
};

export const getFlowKey = (flowType: string) => {
  switch (flowType) {
    case "prescription-lenses":
      return 1;
    case "protective-lenses":
      return 2;
    case "reading-lenses":
      return 3;
    default:
      return 0;
  }
};

// sph values
export const getSphValues = () => {
  const values = [];
  for (let i = -20; i <= 16; i += 0.25) {
    values.push(i.toFixed(2));
  }
  return values;
};

// axis values
export const getAxisValues = () => {
  const values = [];
  for (let i = 0; i <= 180; i += 1) {
    values.push(i);
  }
  return values;
};

// cylinder values
export const getCylinderValues = () => {
  const values = [];
  for (let i = -12; i <= 12; i += 0.25) {
    values.push(i.toFixed(2));
  }
  return values;
};

// add values
export const getAddValues = () => {
  const values = [];
  for (let i = 0.25; i <= 6; i += 0.25) {
    values.push(i.toFixed(2));
  }
  return values;
};

export const getPDValues = () => {
  const values = [];
  for (let i = 50; i <= 80; i += 0.5) {
    values.push(i.toFixed(1));
  }
  return values;
};

export const getContactSizeValues = () => {
  const values = [];
  for (let i = -20; i <= 20; i += 1) {
    values.push(i.toFixed(1));
  }
  return values;
};

export const formatOrder = (orders: any[], form: FormData) => {
  orders.forEach((orderBody, index) => {
    Object.keys(orderBody).forEach((key) => {
      if (!!orderBody[key]) {
        if (key == "rx") {
          Object.keys(orderBody["rx"]).forEach((rxKey) => {
            if (
              orderBody["rx"][rxKey] != "" &&
              orderBody["rx"][rxKey] != null &&
              orderBody["rx"][rxKey] != "0.00" &&
              orderBody["rx"][rxKey] != 0
            ) {
              form.append(
                `orders[${index}][rx][${rxKey}]`,
                orderBody["rx"][rxKey]
              );
            }
          });
        } else if (key == "images") {
          orderBody[key].forEach((val: any, innerIndex: number) => {
            form.append(`orders[${index}][${key}][${innerIndex}]`, val.file);
          });
        } else if (key == "options") {
          orderBody[key].forEach((val: any, innerIndex: number) => {
            form.append(`orders[${index}][${key}][${innerIndex}]`, val);
          });
        } else {
          form.append(`orders[${index}][${key}]`, orderBody[key]);
        }
      }
    });
  });
  return form;
};
// Usage:
// utf8_to_b64("✓ à la mode"); // "4pyTIMOgIGxhIG1vZGU="
// b64_to_utf8("4pyTIMOgIGxhIG1vZGU="); // "✓ à la mode"

export function utf8_to_b64(str: string) {
  return window.btoa(unescape(encodeURIComponent(str)));
}
export function b64_to_utf8(str: string) {
  try {
    return decodeURIComponent(escape(window.atob(str)));
  } catch (e) {
    return str;
  }
}

/** URL-safe base64 encode (for phone in path): no + or / so URL doesn't alter it */
export function utf8_to_b64_url_safe(str: string) {
  const b64 = window.btoa(unescape(encodeURIComponent(str)));
  return b64.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

/** URL-safe base64 decode (handles - _ and space that URL may have turned + into) */
export function b64_url_safe_to_utf8(str: string) {
  if (!str || typeof str !== "string") return "";
  try {
    let b64 = str.replace(/\s/g, "+").replace(/-/g, "+").replace(/_/g, "/");
    const pad = b64.length % 4;
    if (pad) b64 += "=".repeat(4 - pad);
    return decodeURIComponent(escape(window.atob(b64)));
  } catch {
    return str;
  }
}

export function groupByKey(array: any[], key: string) {
  return array.reduce((hash, obj) => {
    if (obj[key] === undefined) return hash;
    return Object.assign(hash, {
      [obj[key]]: (hash[obj[key]] || []).concat(obj),
    });
  }, {});
}

export const isSupported = () =>
  "Notification" in window &&
  "serviceWorker" in navigator &&
  "PushManager" in window;

export const getFirebaseErrorMessage = (errorCode: string) => {
  switch (errorCode) {
    case "auth/invalid-email":
      return "البريد الإلكتروني غير صحيح";
    case "auth/user-disabled":
      return "المستخدم معطل";
    case "auth/user-not-found":
      return "المستخدم غير موجود";
    case "auth/wrong-password":
      return "كلمة المرور غير صحيحة";
    case "auth/email-already-in-use":
      return "البريد الإلكتروني مستخدم من قبل";
    case "auth/weak-password":
      return "كلمة المرور ضعيفة";
    case "auth/operation-not-allowed":
      return "العملية غير مسموحة";
    case "auth/account-exists-with-different-credential":
      return "الحساب موجود ببيانات مختلفة";
    case "auth/invalid-credential":
      return "بيانات غير صحيحة";
    case "auth/invalid-verification-code":
      return "كود التحقق غير صحيح";
    case "auth/invalid-verification-id":
      return "رقم التحقق غير صحيح";
    case "auth/missing-verification-code":
      return "كود التحقق مفقود";
    case "auth/too-many-requests":
      return "لقد تم ارسال الكثير من رسائل التحقق, يرجى المحاولة لاحقا";
    case "auth/credential-already-in-use":
      return "البيانات مستخدمة من قبل";
    case "auth/invalid-phone-number":
      return "رقم الهاتف غير صحيح";
    case "auth/missing-phone-number":
      return "رقم الهاتف مفقود";
    case "auth/quota-exceeded":
      return "تم تجاوز الحد المسموح به";
    case "auth/code-expired":
      return "انتهت صلاحية الكود ، يرجى إعادة إرسال الكود مرة أخرى";
    default:
      return "حدث خطأ غير معروف ، يرجى المحاولة لاحقا";
  }
};

/** Vanex shipping: get delivery price from our backend (Vanex). Pass api (useApi()) when available so the request uses auth base URL. */
export const calcDeliveryPrice = async (
  distance: { city: string; address: string },
  api?: { get: (url: string, config?: any) => Promise<{ data: any }> }
) => {
  const baseURL =
    (import.meta.env.VITE_API_URL as string | undefined)?.trim() || "https://api.locoptics.ly/api";
  const params = { city: distance.city, address: distance.address || distance.city };

  try {
    const response = api
      ? await api.get("/shipping/price", { params })
      : await axios.get(`${baseURL}/shipping/price`, { params });
    const data = response.data ?? {};
    const price = Number(data.price);
    return {
      messages: data.messages ?? "لا يوجد توصيل لهذه المنطقة عبر فانكس",
      status: data.status ?? true,
      data: data.data ?? null,
      price: Number.isFinite(price) ? price : 0,
      code: data.code ?? 200,
    };
  } catch (e) {
    console.warn("Vanex delivery price API failed:", e);
    throw e;
  }
};
